// extracted by mini-css-extract-plugin
var _1 = "PostTopicWithBreadcrumbs-module__animateUploadProgressBarWidth--CM8qa";
var _2 = "PostTopicWithBreadcrumbs-module__animatedBackground--mN28T";
var _3 = "PostTopicWithBreadcrumbs-module__link--ekbis";
var _4 = "PostTopicWithBreadcrumbs-module__remove--_2J0E";
var _5 = "PostTopicWithBreadcrumbs-module__removeButton--lo60k";
var _6 = "PostTopicWithBreadcrumbs-module__topicNameContainer--T6FhH";
var _7 = "PostTopicWithBreadcrumbs-module__topicNameInner--VBrYt";
export { _1 as "animateUploadProgressBarWidth", _2 as "animatedBackground", _3 as "link", _4 as "remove", _5 as "removeButton", _6 as "topicNameContainer", _7 as "topicNameInner" }
